export default __webpack_public_path__ + "static/media/AR-2.7b3eaa8b.jpg";